export default __webpack_public_path__ + "media/Preview.60f5a01e.svg";